<template>
  <echarts :options="options" class="chart-stage"></echarts>
</template>
<script>
import echarts from "./basic";
import "echarts/lib/chart/line";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/legend";

export default {
  props: {
    category: {
      type: Array,
    },
    area: {
      type: Boolean,
      default: true
    },
    data: {
      type: Array,
      required: true
    },
    grid: {
      type: Object,
      default() {
        return {}
      }
    },
    unit: {
      type: String,
      default: ''
    },
    unitX: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      lineColor: ['#ff7c79', '#f19149', '#22ac38','#00a0e9'],
      areaColor: ['#fed9d8', '#fbdfca', '#bde7c4','#bde7f9']
    }
  },
  computed: {
    options() {
      let series = [], legends = []
      console.log(this.data);
      this.data.forEach((ele, index) => {
        let serieData = []
        legends.push(ele.name)
        ele.value.forEach((item, i) => {
          serieData.push([this.category[i], item])
        })
        series.push({
          name: ele.name,
          type: 'line',
          smooth: true,
          symbol: 'none',
          areaStyle: {
            color: this.area ? this.areaColor[index] : 'transparent'
          },
          data: serieData
        })
      })
      let grid = {
        ...{
          top: "45",
          left: "60",
          right: "30",
          bottom: "55"
        }, ...this.grid
      }
      return {
        color: this.lineColor,
        tooltip: {
          trigger: "axis",
          backgroundColor: "#fff",
          borderColor: "#eee",
          borderWidth: "1",
          textStyle: {
            color: '#666',
            fontSize: 12
          },
          axisPointer: {
            type: "cross",
            label: {
              backgroundColor: "#6a7985"
            }
          }
        },
        legend: {
          bottom: '0',
          data: legends,
          selectedMode: 'multiple'
        },
        grid,
        xAxis: [
          {
            type: 'time',
            name: this.unitX,
            axisLine: {
              lineStyle: {
                color: '#aaa'
              }
            },
            axisLabel: {
              color: '#666',
              formatter: (value) => {
                return this.$filter.formatDate(new Date(value), 'hh')
              }
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#ddd'
              }
            },
            splitNumber: 24,
            max: (value) => {
              return new Date(this.$filter.formatDate(new Date(value.max), 'yyyy-MM-dd') + ' 24:00:00').getTime()
            },
            min: (value) => {
              return new Date(this.$filter.formatDate(new Date(value.min), 'yyyy-MM-dd') + ' 00:00:00').getTime()
            },
            axisPointer: {
              type: 'line',
              lineStyle: {
                color: '#ccc'
              }
            },
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name: this.unit,
            axisLine: {
              lineStyle: {
                color: '#aaa'
              }
            },
            axisLabel: {
              color: '#666'
            },
            axisPointer: {
              show: false,
            },
            splitLine: {
              lineStyle: {
                type: 'dashed',
                color: '#ddd'
              }
            }
          }
        ],
        series
      }
    }
  },
  components: {
    echarts
  }
};
</script>
<style lang="less" scoped>
.chart-stage {
  height: 100%;
}
</style>